import { BottomTabNavigationOptions } from '@react-navigation/bottom-tabs'
import { Theme } from '@react-navigation/native'
import { useTheme, useColorMode } from 'native-base'
import { useMemo } from 'react'

import { darkNavigationTheme, lightNavigationTheme } from '~constants'

type ReturnValues = {
  navigationTheme: Theme
  tabBarTheme: BottomTabNavigationOptions
}

export const useNavigationTheme = (): ReturnValues => {
  const { colorMode } = useColorMode()
  const { colors } = useTheme()

  const tabBarTheme: BottomTabNavigationOptions = useMemo(
    () => ({
      tabBarActiveTintColor: colors.actionBlue,
      tabBarInactiveTintColor: colors.offMain,
    }),
    [colors.actionBlue, colors.offMain]
  )

  const navigationTheme = colorMode === 'dark' ? darkNavigationTheme : lightNavigationTheme

  return {
    navigationTheme,
    tabBarTheme,
  }
}
